const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    featured: "all",
    searchText: "",
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        filterByfeatured: (state, action) => {
            state.featured = action.payload;
        },
        filterBySearchText: (state, action) => {
            state.searchText = action.payload;
        },
    },
});

export default filterSlice.reducer;
export const { filterByfeatured, filterBySearchText } = filterSlice.actions;
